// @generated by protobuf-ts 2.11.1 with parameter generate_dependencies,long_type_number,ts_nocheck,optimize_code_size
// @generated from protobuf file "c1/api/assets/v1/profile_type_icons.proto" (package "c1.api.assets.v1", syntax proto3)
// tslint:disable
// @ts-nocheck
import { ServiceType } from "@protobuf-ts/runtime-rpc";
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
import { SrcSet } from "./images";
/**
 * @generated from protobuf message c1.api.assets.v1.ProfileTypeIcon
 */
export interface ProfileTypeIcon {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIconRef profile_type_icon = 1
     */
    profileTypeIcon?: ProfileTypeIconRef;
    /**
     * @generated from protobuf field: string src = 2
     */
    src: string;
    /**
     * @generated from protobuf field: c1.api.assets.v1.SrcSet src_set = 3
     */
    srcSet?: SrcSet;
}
/**
 * @generated from protobuf message c1.api.assets.v1.ProfileTypeIconRef
 */
export interface ProfileTypeIconRef {
    /**
     * @generated from protobuf field: string profile_type_id = 1
     */
    profileTypeId: string;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetProfileTypeIconRequest
 */
export interface GetProfileTypeIconRequest {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIconRef profile_type_icon_ref = 1
     */
    profileTypeIconRef?: ProfileTypeIconRef;
}
/**
 * @generated from protobuf message c1.api.assets.v1.GetProfileTypeIconResponse
 */
export interface GetProfileTypeIconResponse {
    /**
     * @generated from protobuf field: c1.api.assets.v1.ProfileTypeIcon profile_type_icon = 1
     */
    profileTypeIcon?: ProfileTypeIcon;
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsRequest
 */
export interface BulkGetProfileTypeIconsRequest {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.ProfileTypeIconRef profile_type_icons = 1
     */
    profileTypeIcons: ProfileTypeIconRef[];
}
/**
 * @generated from protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsResponse
 */
export interface BulkGetProfileTypeIconsResponse {
    /**
     * @generated from protobuf field: repeated c1.api.assets.v1.ProfileTypeIcon list = 1
     */
    list: ProfileTypeIcon[];
}
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeIcon$Type extends MessageType<ProfileTypeIcon> {
    constructor() {
        super("c1.api.assets.v1.ProfileTypeIcon", [
            { no: 1, name: "profile_type_icon", kind: "message", T: () => ProfileTypeIconRef },
            { no: 2, name: "src", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 3, name: "src_set", kind: "message", T: () => SrcSet }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeIcon>): ProfileTypeIcon {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.src = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeIcon>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeIcon): ProfileTypeIcon {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.ProfileTypeIconRef profile_type_icon */ 1:
                    message.profileTypeIcon = ProfileTypeIconRef.internalBinaryRead(reader, reader.uint32(), options, message.profileTypeIcon);
                    break;
                case /* string src */ 2:
                    message.src = reader.string();
                    break;
                case /* c1.api.assets.v1.SrcSet src_set */ 3:
                    message.srcSet = SrcSet.internalBinaryRead(reader, reader.uint32(), options, message.srcSet);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeIcon, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.ProfileTypeIconRef profile_type_icon = 1; */
        if (message.profileTypeIcon)
            ProfileTypeIconRef.internalBinaryWrite(message.profileTypeIcon, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        /* string src = 2; */
        if (message.src !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.src);
        /* c1.api.assets.v1.SrcSet src_set = 3; */
        if (message.srcSet)
            SrcSet.internalBinaryWrite(message.srcSet, writer.tag(3, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.ProfileTypeIcon
 */
export const ProfileTypeIcon = new ProfileTypeIcon$Type();
// @generated message type with reflection information, may provide speed optimized methods
class ProfileTypeIconRef$Type extends MessageType<ProfileTypeIconRef> {
    constructor() {
        super("c1.api.assets.v1.ProfileTypeIconRef", [
            { no: 1, name: "profile_type_id", kind: "scalar", T: 9 /*ScalarType.STRING*/, options: { "validate.rules": { string: { pattern: "^[a-zA-Z0-9]{27}$" } } } }
        ]);
    }
    create(value?: PartialMessage<ProfileTypeIconRef>): ProfileTypeIconRef {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeId = "";
        if (value !== undefined)
            reflectionMergePartial<ProfileTypeIconRef>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: ProfileTypeIconRef): ProfileTypeIconRef {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string profile_type_id */ 1:
                    message.profileTypeId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: ProfileTypeIconRef, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string profile_type_id = 1; */
        if (message.profileTypeId !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.profileTypeId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.ProfileTypeIconRef
 */
export const ProfileTypeIconRef = new ProfileTypeIconRef$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfileTypeIconRequest$Type extends MessageType<GetProfileTypeIconRequest> {
    constructor() {
        super("c1.api.assets.v1.GetProfileTypeIconRequest", [
            { no: 1, name: "profile_type_icon_ref", kind: "message", T: () => ProfileTypeIconRef }
        ]);
    }
    create(value?: PartialMessage<GetProfileTypeIconRequest>): GetProfileTypeIconRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetProfileTypeIconRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfileTypeIconRequest): GetProfileTypeIconRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.ProfileTypeIconRef profile_type_icon_ref */ 1:
                    message.profileTypeIconRef = ProfileTypeIconRef.internalBinaryRead(reader, reader.uint32(), options, message.profileTypeIconRef);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfileTypeIconRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.ProfileTypeIconRef profile_type_icon_ref = 1; */
        if (message.profileTypeIconRef)
            ProfileTypeIconRef.internalBinaryWrite(message.profileTypeIconRef, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetProfileTypeIconRequest
 */
export const GetProfileTypeIconRequest = new GetProfileTypeIconRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class GetProfileTypeIconResponse$Type extends MessageType<GetProfileTypeIconResponse> {
    constructor() {
        super("c1.api.assets.v1.GetProfileTypeIconResponse", [
            { no: 1, name: "profile_type_icon", kind: "message", T: () => ProfileTypeIcon }
        ]);
    }
    create(value?: PartialMessage<GetProfileTypeIconResponse>): GetProfileTypeIconResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        if (value !== undefined)
            reflectionMergePartial<GetProfileTypeIconResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: GetProfileTypeIconResponse): GetProfileTypeIconResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* c1.api.assets.v1.ProfileTypeIcon profile_type_icon */ 1:
                    message.profileTypeIcon = ProfileTypeIcon.internalBinaryRead(reader, reader.uint32(), options, message.profileTypeIcon);
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: GetProfileTypeIconResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* c1.api.assets.v1.ProfileTypeIcon profile_type_icon = 1; */
        if (message.profileTypeIcon)
            ProfileTypeIcon.internalBinaryWrite(message.profileTypeIcon, writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.GetProfileTypeIconResponse
 */
export const GetProfileTypeIconResponse = new GetProfileTypeIconResponse$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetProfileTypeIconsRequest$Type extends MessageType<BulkGetProfileTypeIconsRequest> {
    constructor() {
        super("c1.api.assets.v1.BulkGetProfileTypeIconsRequest", [
            { no: 1, name: "profile_type_icons", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeIconRef, options: { "validate.rules": { repeated: { minItems: "1", maxItems: "100" } } } }
        ]);
    }
    create(value?: PartialMessage<BulkGetProfileTypeIconsRequest>): BulkGetProfileTypeIconsRequest {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.profileTypeIcons = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetProfileTypeIconsRequest>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetProfileTypeIconsRequest): BulkGetProfileTypeIconsRequest {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.ProfileTypeIconRef profile_type_icons */ 1:
                    message.profileTypeIcons.push(ProfileTypeIconRef.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetProfileTypeIconsRequest, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.ProfileTypeIconRef profile_type_icons = 1; */
        for (let i = 0; i < message.profileTypeIcons.length; i++)
            ProfileTypeIconRef.internalBinaryWrite(message.profileTypeIcons[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsRequest
 */
export const BulkGetProfileTypeIconsRequest = new BulkGetProfileTypeIconsRequest$Type();
// @generated message type with reflection information, may provide speed optimized methods
class BulkGetProfileTypeIconsResponse$Type extends MessageType<BulkGetProfileTypeIconsResponse> {
    constructor() {
        super("c1.api.assets.v1.BulkGetProfileTypeIconsResponse", [
            { no: 1, name: "list", kind: "message", repeat: 2 /*RepeatType.UNPACKED*/, T: () => ProfileTypeIcon }
        ]);
    }
    create(value?: PartialMessage<BulkGetProfileTypeIconsResponse>): BulkGetProfileTypeIconsResponse {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.list = [];
        if (value !== undefined)
            reflectionMergePartial<BulkGetProfileTypeIconsResponse>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: BulkGetProfileTypeIconsResponse): BulkGetProfileTypeIconsResponse {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* repeated c1.api.assets.v1.ProfileTypeIcon list */ 1:
                    message.list.push(ProfileTypeIcon.internalBinaryRead(reader, reader.uint32(), options));
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: BulkGetProfileTypeIconsResponse, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* repeated c1.api.assets.v1.ProfileTypeIcon list = 1; */
        for (let i = 0; i < message.list.length; i++)
            ProfileTypeIcon.internalBinaryWrite(message.list[i], writer.tag(1, WireType.LengthDelimited).fork(), options).join();
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message c1.api.assets.v1.BulkGetProfileTypeIconsResponse
 */
export const BulkGetProfileTypeIconsResponse = new BulkGetProfileTypeIconsResponse$Type();
/**
 * @generated ServiceType for protobuf service c1.api.assets.v1.ProfileTypeIconService
 */
export const ProfileTypeIconService = new ServiceType("c1.api.assets.v1.ProfileTypeIconService", [
    { name: "GetProfileTypeIcon", options: { "authz.method": { role: "VIEWER" } }, I: GetProfileTypeIconRequest, O: GetProfileTypeIconResponse },
    { name: "BulkGetProfileTypeIcons", options: { "authz.method": { role: "VIEWER" } }, I: BulkGetProfileTypeIconsRequest, O: BulkGetProfileTypeIconsResponse }
]);
